module.exports = __webpack_public_path__ + "img/32-chrome.dd689757.png";